<template>
    <div>
        <div class=" row mb-2">
            <label class="col-sm-4  text-lr lh40"><i
                    v-if=" Data.data.c_priority==='S'"
                    class="fa fa-asterisk text-danger font10 ml-1"
                    aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
            <div class="col-sm-7 flex1 lh35">
                <el-input style="margin-bottom: 0px" size=""
                          :disabled="disabled"
                          @change="$get_function(Data,value)"
                          v-model=" value "
                          placeholder="请输入内容"></el-input>
                <span class="ml-2">{{ Data.data.c_unit }} </span>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name: "inputBox",
    props: [
        'Data'
    ],
    data() {
        return {
            value: this.Data.data.c_value,
          disabled: this.Data.attr.disabled===undefined?false:this.Data.attr.disabled,
        };
    },
    mounted() {

    },
    methods: {},
}
;
</script>

<style scoped>


.test .el-input {
    width: 200px;
    margin: 10px 0;
}
</style>

